import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    backgroundColor: theme.colors.white,
  },
  loginContainer: {
    flex: 1,
    backgroundColor: theme.colors.white,
  },
  passwordSubmit: {
    backgroundColor: theme.appTheme.primary,
    marginTop: theme.spacings.md,
    padding: theme.spacings.md,
    borderRadius: theme.borderRadii.md,
  },
  formContent: {
    width: '50%',
    maxWidth: 600,
  },
  fieldSpacing: {
    marginTop: theme.spacings.md,
  },
  submitText: {
    fontSize: theme.fontSizes.xl,
    textAlign: 'center',
    color: theme.colors.white,
  },
});
